import { render, staticRenderFns } from "./ContentOffice.vue?vue&type=template&id=2bfd7f66&scoped=true&"
import script from "./ContentOffice.vue?vue&type=script&lang=js&"
export * from "./ContentOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd7f66",
  null
  
)

export default component.exports